import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicBoard from "@/pages/PublicBoard";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import OpportunityForm from "@/pages/OpportunityForm";
import EmbedBoard from "@/pages/EmbedBoard";
import Poster from "@/pages/Poster";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import BlogEditor from "@/pages/BlogEditor";
import usePageTracker from "@/lib/track";

function RouterBody() {
  usePageTracker();
  return (
    <Routes>
      <Route path="/" element={<PublicBoard />} />
      <Route path="/opportunity/:id" element={<OpportunityDetail />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:id" element={<BlogPost />} />
      <Route path="/embed" element={<EmbedBoard />} />
      <Route path="/poster" element={<Poster />} />
      <Route path="/staff/login" element={<Login />} />
      <Route path="/staff" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/staff/new" element={<ProtectedRoute><OpportunityForm /></ProtectedRoute>} />
      <Route path="/staff/edit/:id" element={<ProtectedRoute><OpportunityForm /></ProtectedRoute>} />
      <Route path="/staff/blog/new" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
      <Route path="/staff/blog/edit/:id" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouterBody />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                border: "2px solid black",
                borderRadius: "12px",
                boxShadow: "4px 4px 0px 0px rgba(0,0,0,1)",
                fontFamily: "Outfit, sans-serif",
                fontWeight: 600,
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
